import mediator from './mediator';
import breakpoint from './breakpoint';

export default class ProductNotification {

    constructor(elm) {
        this.button = $(elm);
        this.wrapper = this.button.closest('.js-product-page__buy');
        this.form = this.wrapper.find('.js-notification__form');
        this.infoClass = "state--show-info";
        this.notificationClass = "state--notification";
	}

    init() {
        this.bindings();
	}

	bindings() {
        this.button.on('click', e => {
            // only prevent default if mobile and target is a link
            if ($(window).width() > breakpoint.sizes.md && e.target.nodeName == "A") {
                e.preventDefault();
            }
            this.setState(this.button.attr('data-js-product-notification'));
        });
        this.form.on('submit', e => {
            e.preventDefault();
            this.submitNotification(e);
        });
    }

    setState(state) {
        //State 1 = notification
        //State 2 = store info

        if (state == "1") {
            this.wrapper.toggleClass(this.notificationClass).removeClass(this.infoClass);
        } else if (state == "2") {
            this.wrapper.removeClass(this.notificationClass).toggleClass(this.infoClass);
        } else {
            console.log('no state');
        }
    }

    submitNotification(e) {
        const target = $(e.target);
        const action = target.attr('action');
        const method = target.attr('method');
        console.log(target);

        $.ajax({
            type: method,
            url: action,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            dataType: 'JSON',
            success: (response) => {
                console.log(response);
            }
        }).done(() => {
        
        }).fail((response) => {
            console.log(response);
        });
    }
}
